module.exports = __webpack_public_path__ + "img/logo-dark.7bcd9b3b.svg";